// Inspired by https://github.com/petermoresi/react-download-link
import * as React from 'react'
import { Button } from 'react-bootstrap'

export const exportXLSX = (data, sheetname, filename, options = {}) => {
  import('xlsx')
    .then(async XLSX => {
      // Create XLSX
      let wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
      let ws = XLSX.utils.json_to_sheet(data, options)
      let workbook = { SheetNames: [sheetname], Sheets: {} }
      workbook.Sheets[sheetname] = ws
      let wbout = XLSX.write(workbook, wopts)
      function s2ab(s) {
        let buf = new ArrayBuffer(s.length)
        let view = new Uint8Array(buf)
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }

      // Create ObjectURL from Blob
      let reader = new FileReader()
      let blob = new Blob([s2ab(wbout)], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      reader.onload = function () {
        let element = document.createElement('a')
        if (!document.body) throw new Error()
        document.body.appendChild(element)
        element.setAttribute('href', reader.result)
        element.setAttribute('download', filename)
        element.style.display = ''
        element.click()
        document.body.removeChild(element)
        return true
      }
      reader.readAsDataURL(blob)
    })
    .catch(error => {
      throw error
    })
}

//TODO: probably deprecated
export class DownloadLink extends React.Component {
  static defaultProps = {
    label: 'Scarica',
    data: [],
    sheetname: 'Tracciato Record',
    filename: 'export.xlsx',
    style: {},
  }

  handleDownloadClick = e => {
    e.preventDefault()
    e.stopPropagation()
    exportXLSX(this.props.data, this.props.sheetname, this.props.filename)
  }

  render() {
    return (
      <a href="/" style={{ ...this.props.style, cursor: 'pointer' }} onClick={this.handleDownloadClick}>
        {this.props.label}
      </a>
    )
  }
}

//TODO: probably deprecated
class DownloadXLSX extends React.Component {
  static defaultProps = {
    label: 'Scarica',
    data: [],
    sheetname: 'Tracciato Record',
    filename: 'export.xlsx',
    style: {},
    mode: 'link',
  }

  downloadLink = null

  render() {
    if (this.props.mode === 'link') {
      return <DownloadLink {...this.props} />
    } else {
      let props = { ...this.props }
      delete props.label
      return (
        <Button
          content={
            <DownloadLink
              ref={dl => {
                this.downloadLink = dl
              }}
              label={this.props.label}
              filename={this.props.filename}
              data={this.props.data}
              sheetname={this.props.sheetname}
              style={{ color: 'white' }}
            />
          }
          onClick={e => {
            if (this.downloadLink) {
              this.downloadLink.handleDownloadClick(e)
            }
          }}
          {...props}
        />
      )
    }
  }
}

export default DownloadXLSX
